<template>
  <div id="wangeditor">
    <div ref="editorElem" style="text-align:left;"></div>
  </div>
</template>
<script>
import E from "wangeditor";
export default {
  name: "Editor",
  data() {
    return {
      editor: null,
      editorContent: "",
      text: ""
    };
  },
  props: {
    info: String
  },

  watch: {
    info: function(vall) {
      this.text = vall;
      this.geting()
    }
  },
  methods: {
    geting() {
      this.editor = new E(this.$refs.editorElem);
      // 编辑器的事件，每次改变会获取其html内容

      this.editor.customConfig.onchange = html => {
        this.editorContent = html;
        this.$emit("change_edit", this.editorContent);
        this.$emit("change_edit1", this.editorContent);
        // this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件
      };
      this.editor.customConfig.uploadImgServer =
        "https://www.bioflin.com:83/admin/edit_upload_img";
      this.editor.customConfig.menus = [
        // 菜单配置
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "code", // 插入代码
        "undo", // 撤销
        "redo" // 重复
      ];
      const _this = this;
      this.editor.customConfig.customUploadImg = function(files, insert) {
        // files 是 input 中选中的文件列表
        // insert 是获取图片 url 后，插入到编辑器的方法
        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        // console.log(this.$cookies.get("token"))
        var formData = new FormData();
        formData.append("img", files[0]);
        // formData.append("token", "5615fbd852ad8ee0690ce74ac89518e0");
        _this.axios
          .post(
            "https://www.bioflin.com:83/admin/edit_upload_img",
            formData,
            config
          )
          .then(res => {
            insert(res.data.data);
          });
        // 上传代码返回结果之后，将图片插入到编辑器中
      };

      this.editor.create();
      this.editor.txt.html(this.text);
    }
  },
  mounted() {
    this.geting()
  }
};
</script>
